import type { LocaleMorpheus } from "@solvari/translations";

import { ky, memoize, returnError } from "@solvari/utils";

import type {
  Redirect,
  RedirectIndex,
} from "~/shared/libs/redirectMatching.ts";

import { toInternalUrl } from "~/shared/composables/useHost.ts";
import { withHardcodedRedirects } from "~/shared/libs/hardcodedRedirects.ts";
import { toRedirectIndex } from "~/shared/libs/redirectMatching.ts";

// Client-only caller → no page entry to tag. Server uses its own fetch in redirects.ts.
const getRedirects = memoize(
  returnError(async (locale: LocaleMorpheus): Promise<RedirectIndex> => {
    const redirects = await ky
      .get(toInternalUrl("/cache-proxy/api/v4/main-site/redirects"), {
        searchParams: { localeCode: locale },
        timeout: 20_000,
      })
      .json<Redirect[]>();

    return toRedirectIndex(withHardcodedRedirects(redirects, locale));
  }),
  {
    key: (locale) => locale,
    staleTime: 15 * 60 * 1000,
  },
);

export { getRedirects };
